export interface IOverflowsQuotaParams {
  // Time still available on the quota; `undefined`/`null` means no quota applies.
  remainingMinutes?: number | null;
  // Duration the user is about to book.
  requestedMinutes: number;
  // Time already counted against the quota by the booking being edited, if any - it is credited
  // back so that only extending a booking beyond what was already booked can overflow.
  creditedMinutes?: number;
}

export const overflowsQuota = ({ remainingMinutes, requestedMinutes, creditedMinutes = 0 }: IOverflowsQuotaParams): boolean => {
  if (remainingMinutes === undefined || remainingMinutes === null) {
    return false;
  }

  return requestedMinutes > remainingMinutes + creditedMinutes;
};
